import { Check, ChevronDown, SlidersHorizontal, Store, Truck, X } from "lucide-react";

const DIETARY = [
  { value: "", label: "All diets" },
  { value: "vegetarian", label: "Vegetarian" },
  { value: "vegan", label: "Vegan" },
  { value: "gluten free", label: "Gluten free" },
  { value: "halal", label: "Halal" },
];

const PRICES = [
  { value: "", label: "Any price" },
  { value: "under15", label: "Under $15" },
  { value: "15to25", label: "$15–$25" },
  { value: "25plus", label: "$25+" },
];

function Pill({ active, onClick, icon: Icon, children, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      aria-pressed={active}
      className={`inline-flex min-h-11 shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-xs font-extrabold transition ${
        active
          ? "border-[#0b2340] bg-[#0b2340] text-white"
          : "border-[#e3d9cc] bg-white text-[#35404b] hover:border-[#d35400] hover:text-[#b04600]"
      }`}
    >
      {Icon ? <Icon size={14} strokeWidth={2} aria-hidden="true" /> : null}
      {children}
      {active ? <Check size={13} aria-hidden="true" /> : null}
    </button>
  );
}

export default function MarketplaceFilterBar({
  fulfillment,
  onFulfillment,
  dietary,
  onDietary,
  price,
  onPrice,
  onClear,
}) {
  const hasFilters = Boolean(fulfillment || dietary || price);

  return (
    <div className="relative rounded-2xl border border-[#e8ded2] bg-[#FFF9F2] p-3 shadow-[0_12px_28px_-25px_rgba(11,35,64,.45)]" data-testid="marketplace-filter-bar">
      <div className="flex items-center gap-2 overflow-x-auto pb-1 pr-8 ap-no-scrollbar">
        <div className="mr-1 inline-flex shrink-0 items-center gap-2 px-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-[#4b5563]">
          <SlidersHorizontal size={14} aria-hidden="true" /> Filters
        </div>
        <Pill active={!fulfillment} onClick={() => onFulfillment("")} testid="filter-fulfillment-all">Any fulfillment</Pill>
        <Pill active={fulfillment === "pickup"} onClick={() => onFulfillment(fulfillment === "pickup" ? "" : "pickup")} icon={Store} testid="filter-pickup">Pickup</Pill>
        <Pill active={fulfillment === "delivery"} onClick={() => onFulfillment(fulfillment === "delivery" ? "" : "delivery")} icon={Truck} testid="filter-delivery">Delivery</Pill>

        <label className="relative shrink-0">
          <span className="sr-only">Dietary preference</span>
          <select
            value={dietary}
            onChange={(event) => onDietary(event.target.value)}
            data-testid="filter-dietary"
            className={`min-h-11 appearance-none rounded-full border bg-white pl-4 pr-9 text-xs font-extrabold outline-none transition ${
              dietary ? "border-[#d35400] text-[#b04600]" : "border-[#e3d9cc] text-[#35404b]"
            }`}
          >
            {DIETARY.map((option) => <option key={option.value || "all"} value={option.value}>{option.label}</option>)}
          </select>
          <ChevronDown size={13} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
        </label>

        <label className="relative shrink-0">
          <span className="sr-only">Price range</span>
          <select
            value={price}
            onChange={(event) => onPrice(event.target.value)}
            data-testid="filter-price"
            className={`min-h-11 appearance-none rounded-full border bg-white pl-4 pr-9 text-xs font-extrabold outline-none transition ${
              price ? "border-[#d35400] text-[#b04600]" : "border-[#e3d9cc] text-[#35404b]"
            }`}
          >
            {PRICES.map((option) => <option key={option.value || "all"} value={option.value}>{option.label}</option>)}
          </select>
          <ChevronDown size={13} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
        </label>

        {hasFilters && (
          <button
            type="button"
            onClick={onClear}
            data-testid="filter-clear"
            className="inline-flex min-h-11 shrink-0 items-center gap-1 rounded-full px-3 text-xs font-bold text-[#4b5563] hover:text-[#b04600]"
          >
            <X size={13} /> Clear
          </button>
        )}
      </div>
      <div className="pointer-events-none absolute right-0 top-2 h-12 w-8 bg-gradient-to-l from-[#FFF9F2] via-[#FFF9F2]/85 to-transparent sm:hidden" aria-hidden="true" />
      {dietary && (
        <p className="mt-2 px-1 text-[10px] leading-4 text-[#4b5563]" data-testid="dietary-filter-note">
          Dietary labels are based on information provided by each seller. Check the item details or contact the seller if you have an allergy or dietary requirement.
        </p>
      )}
    </div>
  );
}
